import Header from '../header/Header';
import { Box, Text, useDisclosure } from '@chakra-ui/react';
import { useData } from '../../data';
import { useEffect, useState } from 'react';
import Post from './Post';
import CreatePost from './CreatePost';
import FriendRequests from './FriendRequests';
import AdvertFeatureAlt from '../../pages/founder/Dashboard/AdvertFeatureAlt';
import { useWindowSize } from '../../hooks/useWindowSize';
import IsDesktop from '../../utils/IsDesktop';
import RandomFounderCard from './RandomFounderCard';
import ChatMessageWidget from '../ChatMessageWidget';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useSearchParams, useLocation } from 'react-router-dom';
import Trends from './Trends';

const Feed = () => {
  const loggedInUser = useSelector((state) => state?.user?.userInfo);
  const chatWithUserState = useSelector((state) => state?.chat?.chatInfo);

  const [recipient, setRecipient] = useState(chatWithUserState);
  const [recipientId, setRecipientId] = useState(chatWithUserState?.id || null);

  const [connections, setConnections] = useState([]);
  const {
    data: connectionsData,
    isLoading: connectionsLoading,
    refetch: refetchConnections,
  } = useData(
    `users/${loggedInUser?.id}/connections?page_no=1&page_size=10`,
    10000,
  );

  const sortFn = (a, b) =>
    moment(
      b?.lastMessage?.createdAt || b?.connection?.created_at || b?.createdAt,
    ).diff(
      moment(
        a?.lastMessage?.createdAt || a?.connection?.created_at || a?.createdAt,
      ),
      'second',
    );

  const [selectedAdvert, setSelectedAdvert] = useState(null);
  const [advertId, setAdvertId] = useState(null);
  const [isAdvert, setIsAdvert] = useState(false);

  const {
    isOpen: advertsListIsOpen,
    onOpen: onOpenAdvertsList,
    onClose: onCloseAdvertsList,
  } = useDisclosure();

  const {
    isOpen: chatBoxIsOpen,
    onOpen: onOpenChatBox,
    onClose: onCloseChatBox,
    onToggle: onToggleChatBox,
  } = useDisclosure();

  const openChatBox = (recipientId, recipient) => {
    setIsAdvert(false);
    setAdvertId(null);
    setSelectedAdvert(null);
    setRecipientId(recipientId);
    setRecipient(recipient);
    onOpenChatBox();
  };

  const openAdvert = (advertId, advert) => {
    // console.log("opening advert=====", advertId, advert, recipient, recipientId)
    setIsAdvert(true);
    setAdvertId(advertId);
    setSelectedAdvert(advert);
    setRecipient(null);
    setRecipientId(null);
    onOpenChatBox();
  };

  const closeChatBox = () => {
    setRecipientId(null);
    setRecipient(null);
    setAdvertId(null);
    setSelectedAdvert(null);
    onToggleChatBox();
  };

  useEffect(() => {
    if (connectionsData?.data) {
      setConnections(connectionsData?.data?.connections?.sort(sortFn));
    }
    // if (chatWithUserState) {
    //   openChatBox(chatWithUserState?.id, chatWithUserState);
    // }
  }, [connectionsData?.data?.connections, chatWithUserState]);

  const isFromNavigate = () => {
    return (
      chatWithUserState &&
      chatWithUserState?.id === recipientId &&
      chatWithUserState?.connection?.accepted
    );
  };

  // const [page, setPage] = useState(1);

  const [searchParams] = useSearchParams();
  const postId = searchParams.get('postId');
  const location = useLocation();

  const [feed, setFeed] = useState([]);

  const { data: advertsData } = useData('adverts');

  const windowSize = useWindowSize();

  const isDesktop = IsDesktop();

  const {
    data: feedData,
    isLoading: feedDataIsLoading,
    refetch: refetchFeed,
  } = useData(`feed?postId=${postId}`, 10000);

  useEffect(() => {
    refetchFeed();
  }, [location.pathname, searchParams, refetchFeed]);

  const appendToPostList = (post = null) => {
    if (post) setFeed((prev) => [post, ...prev]);
  };

  useEffect(() => {
    setFeed(feedData?.data?.posts || []);
  }, [feedData, feedDataIsLoading]);

  useEffect(() => {
    if (advertsData?.data?.adverts?.length > 0 && windowSize > 1279) {
      onOpenAdvertsList();
    } else {
      onCloseAdvertsList();
    }
  }, [advertsData?.data?.adverts?.length, windowSize]);

  return (
    <>
      <Box className="w-[100%] flex flex-col overflow-hidden">
        <Box>
          <Header title={'feed'} />
          <Box className="flex w-full bg-gray-100">
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto min-h-[89vh] pt-4 px-5 pb-20  w-full max-w-3xl`}
            >
              <Box className="p-3 bg-white mb-5 rounded-lg max-w-2xl mx-auto">
                <CreatePost
                  showCloseButton={false}
                  refetchPost={refetchFeed}
                  appendToPostList={appendToPostList}
                  postId={postId}
                />
              </Box>
              <Box className="w-full flex flex-col gap-5 max-w-2xl mx-auto">
                {feed?.map((post) => {
                  return (
                    <Box key={post.id}>
                      <Box className="w-full bg-white rounded-lg">
                        <Post
                          post={post}
                          refetchPost={refetchFeed}
                          postId={postId}
                        />
                      </Box>

                      {post?.founders?.length > 0 && (
                        <Box className="w-full mt-5">
                          <RandomFounderCard founder={post?.founders[0]} />
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto w-full px-5 max-w-sm hidden lg:flex`}
            >
              <Box className="flex flex-col gap-8 py-4 w-full">
                <FriendRequests />
                <Trends />
              </Box>
            </Box>
            {advertsListIsOpen ? (
              <Box className="hidden bg-white xl:flex flex-col border border-[#DBE2ED] mx-5 my-4 rounded-lg min-w-[270px] max-w-[300px]  min-h-max">
                <Box
                  style={{ boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)' }}
                  className="flex justify-between p-3 border-b border-b-[#DBE2ED] w-full "
                >
                  <Box className="flex items-center w-full gap-1.5">
                    <Text className="font-semibold text-[#2F4B6E]">
                      Featured Adverts
                    </Text>
                  </Box>
                </Box>

                <Box
                  className={`h-full hide-scroll p-3 ${
                    isDesktop ? 'max-h-[100vh] overflow-y-auto' : ''
                  }`}
                >
                  <AdvertFeatureAlt
                    adverts={advertsData?.data?.adverts || []}
                  />
                </Box>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>

      <ChatMessageWidget
        requestListIsOpen={false}
        isDesktop={isDesktop}
        connections={connections}
        setConnections={setConnections}
        refetchConnections={refetchConnections}
        connectionsLoading={connectionsLoading}
        sortFn={sortFn}
        recipient={recipient}
        setRecipient={setRecipient}
        recipientId={recipientId}
        selectedAdvert={selectedAdvert}
        advertId={advertId}
        isAdvert={isAdvert}
        isFromNavigate={isFromNavigate}
        openChatBox={openChatBox}
        openAdvert={openAdvert}
        closeChatBox={closeChatBox}
        chatBoxIsOpen={chatBoxIsOpen}
      />
    </>
  );
};

export default Feed;
